import {
  ERollingOffersInternalViewModel,
  HugeRollingOffer,
  JunesJourneyOffer,
  MatchMastersRollingOffer,
  RoyalMatchRollingOffer,
  StudioDefaultRollingOffer
} from '@appcharge/shared-ui';

export const mapRollingOffers: Record<ERollingOffersInternalViewModel, any> = {
  [ERollingOffersInternalViewModel.HUGE]: HugeRollingOffer,
  [ERollingOffersInternalViewModel.MATCH_MASTERS]: MatchMastersRollingOffer,
  [ERollingOffersInternalViewModel.STUDIO_DEFAULT]: StudioDefaultRollingOffer,
  [ERollingOffersInternalViewModel.JUNES_JOURNEY]: JunesJourneyOffer,
  [ERollingOffersInternalViewModel.ROYAL_MATCH]: RoyalMatchRollingOffer
};

export const mapViewModelRollingDisplayName: Record<
  ERollingOffersInternalViewModel,
  string
> = {
  [ERollingOffersInternalViewModel.HUGE]: 'Huge',
  [ERollingOffersInternalViewModel.MATCH_MASTERS]: 'Match Masters',
  [ERollingOffersInternalViewModel.STUDIO_DEFAULT]: 'Studio',
  [ERollingOffersInternalViewModel.JUNES_JOURNEY]: 'Junes Journey',
  [ERollingOffersInternalViewModel.ROYAL_MATCH]: 'Royal Match'
};
